import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider, FieldArray, getIn } from 'formik';
import { connect } from "react-redux";
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import debounce from 'lodash.debounce';
// material
import {
    Card,
    Stack,
    TextField,
    Container,
    Typography,
    Grid,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { addCarDetail } from '../../actions/carDetailsAction';
import _, { replace } from 'lodash';
import Page from '../../components/Page';
import { styled } from '@mui/material/styles';


// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
    maxWidth: 680,
    margin: 'auto',
    minHeight: '100vh',
    flexDirection: 'column',
    justifyContent: 'center',
}));

function AddCarDetails(props) {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [adminObj, setAdminObj] = useState({});
    const [openUpdate, setOpenUpdate] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [telephoneError, setTelephoneError ] = useState('');
    const [chasisError, setChasisError ] = useState('');
    const [engineError, setEngineError ] = useState('');
    const [balance, setBalance] = useState('1');

    const AddSchema = Yup.object().shape({
        buyer_name: Yup.string().required('Buyer_Name is required'),
        id_no: Yup.string().required('Id no is required'),
        po_box: Yup.string().required('Po Box is required'),
        telephone: Yup.string().required('Telephone is required'),
        model: Yup.string().required('Model is required'),
        motor: Yup.string().required('Motor is required'),
        chasis_no: Yup.string().required('Chasis no is required'),
        engine_no: Yup.string().required('Engine no is required'),
        reg_no: Yup.string().required('Reg no is required'),
        color: Yup.string().required('Color is required'),
        cc: Yup.string().required('CC is required'),
        agreed_price: Yup.number().positive().min(1,"Agreed Price should be greater than 0").required('Agreed Price is required'),
        deposite_price: Yup.number().positive().min(1,"Deposite Price should be greater than 0").required('Deposite Price is required'),
        balance: Yup.string().required('Balance is required')
    });

    const formik = useFormik({
        initialValues: {
            buyer_name:'',
            id_no:'',
            po_box:'',
            telephone:'',
            model:'',
            motor:'',
            chasis_no:'',
            engine_no:'',
            reg_no:'',
            color:'',
            cc:'',
            agreed_price:'',
            deposite_price:'',
            balance:''
        },
    validationSchema: AddSchema,
        onSubmit: (values, {resetForm}) => {
            resetForm();
            setIsLoading(true);
            props.addCarDetail(values);
        }
    });

    useEffect(() => {
        setIsLoading(false);
        if(!_.isEmpty(props.alerts.errors)) {
            setTelephoneError(props.alerts.errors.telephone);
            setEngineError(props.alerts.errors.engine_no);
            setChasisError(props.alerts.errors.chasis_no);
        }
        if(props.alerts.status == 'success') {
            navigate('/dashboard/app', { replace: true });
        }
    }, [props.alerts]);

    useEffect(() => {
        if(values.agreed_price && values.deposite_price) {
            var balance = values.agreed_price-values.deposite_price;
            values.balance = balance;
        } else {
            values.balance = 0;
        }
    });

    const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, handleChange, handleBlur } = formik;

    return (
        <Page title="Add Car Detail">
            <Container maxWidth="lg">
                <Card sx={{padding:"1em"}}>
                    <Stack sx={{ mb: 5 }}>
                        <Typography variant="h4" gutterBottom>
                            Add Car
                        </Typography>
                        <Typography sx={{ color: 'text.secondary' }}>Enter details below.</Typography>
                    </Stack>
                    <FormikProvider value={formik}>
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <fieldset style={{padding:"20px",border:"1px solid #c29136"}}>
                                    <legend style={{padding:"10px"}}>Buyer Details</legend>
                                    <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <TextField
                                                    fullWidth
                                                    type="text"
                                                    label="Buyer Name*"
                                                    {...getFieldProps('buyer_name')}
                                                    error={Boolean(touched.buyer_name && errors.buyer_name)}
                                                    helperText={touched.buyer_name && errors.buyer_name}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                            <TextField
                                                    fullWidth
                                                    type="text"
                                                    label="Id no*"
                                                    {...getFieldProps('id_no')}
                                                    error={Boolean(touched.id_no && errors.id_no)}
                                                    helperText={touched.id_no && errors.id_no}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    fullWidth
                                                    type="text"
                                                    label="Po Box*"
                                                    {...getFieldProps('po_box')}
                                                    error={Boolean(touched.po_box && errors.po_box)}
                                                    helperText={touched.po_box && errors.po_box}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    fullWidth
                                                    type="text"
                                                    label="Telephone no*"
                                                    {...getFieldProps('telephone')}
                                                    error={Boolean(touched.telephone && errors.telephone)}
                                                    helperText={touched.telephone && errors.telephone}
                                                />
                                                <Typography sx={{ color: "red" }}>{telephoneError}</Typography>
                                            </Grid>
                                        </Grid>
                                </fieldset>
                                <fieldset style={{padding:"20px",border:"1px solid #c29136"}}>
                                    <legend style={{padding:"10px"}}>Vehical Detail</legend>
                                    <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                            <TextField
                                                    fullWidth
                                                    type="text"
                                                    label="Model*"
                                                    {...getFieldProps('model')}
                                                    error={Boolean(touched.model && errors.model)}
                                                    helperText={touched.model && errors.model}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    fullWidth
                                                    type="text"
                                                    label="Motor*"
                                                    {...getFieldProps('motor')}
                                                    error={Boolean(touched.motor && errors.motor)}
                                                    helperText={touched.motor && errors.motor}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                            <TextField
                                                    fullWidth
                                                    type="text"
                                                    label="Chasis no*"
                                                    {...getFieldProps('chasis_no')}
                                                    error={Boolean(touched.chasis_no && errors.chasis_no)}
                                                    helperText={touched.chasis_no && errors.chasis_no}
                                                />
                                                <Typography sx={{ color: "red" }}>{chasisError}</Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    fullWidth
                                                    type="text"
                                                    label="Engine no*"
                                                    {...getFieldProps('engine_no')}
                                                    error={Boolean(touched.engine_no && errors.engine_no)}
                                                    helperText={touched.engine_no && errors.engine_no}
                                                />
                                                <Typography sx={{ color: "red" }}>{engineError}</Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                            <TextField
                                                    fullWidth
                                                    type="text"
                                                    label="Reg no*"
                                                    {...getFieldProps('reg_no')}
                                                    error={Boolean(touched.reg_no && errors.reg_no)}
                                                    helperText={touched.reg_no && errors.reg_no}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    fullWidth
                                                    type="text"
                                                    label="Color*"
                                                    {...getFieldProps('color')}
                                                    error={Boolean(touched.color && errors.color)}
                                                    helperText={touched.color && errors.color}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                            <TextField
                                                    fullWidth
                                                    type="text"
                                                    label="CC*"
                                                    {...getFieldProps('cc')}
                                                    error={Boolean(touched.cc && errors.cc)}
                                                    helperText={touched.cc && errors.cc}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    fullWidth
                                                    type="text"
                                                    label="Agreed Price*"
                                                    {...getFieldProps('agreed_price')}
                                                    error={Boolean(touched.agreed_price && errors.agreed_price)}
                                                    helperText={touched.agreed_price && errors.agreed_price}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                            <TextField
                                                    fullWidth
                                                    type="text"
                                                    label="Deposite Price*"
                                                    {...getFieldProps('deposite_price')}
                                                    error={Boolean(touched.deposite_price && errors.deposite_price)}
                                                    helperText={touched.deposite_price && errors.deposite_price}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    fullWidth
                                                    disabled
                                                    type="text"
                                                    label="Balance*"
                                                    {...getFieldProps('balance')}
                                                    error={Boolean(touched.balance && errors.balance)}
                                                    helperText={touched.balance && errors.balance}
                                                />
                                            </Grid>
                                        </Grid>
                                </fieldset>
                            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
                            </Stack>

                            <LoadingButton
                                fullWidth
                                size="large"
                                type="submit"
                                variant="contained"
                                loading={isLoading}
                                sx={{backgroundColor: '#c29136',}}
                            >
                                Add
                            </LoadingButton>
                        </Form>
                    </FormikProvider>
                </Card>
            </Container>
        </Page>
    );
}
const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        alerts: state.alerts,
    }
}

export default connect(mapStateToProps, { addCarDetail })(AddCarDetails);

